module.exports = __webpack_public_path__ + "img/apply-s-ico2.45e44ab2.png";